<mat-card class="dialog-content">
    <mat-card-header class="header-center">
        <img src="../../assets/honeywell_logo.png" alt="honeywell_logo" class="account-logo">
    </mat-card-header>
    <mat-card-content class="account-status">
        <h2 class="account-title"><span class="job-status-date">{{userDetails.orgDesc | lowercase }}</span> Account
            Access Restricted</h2>
        <p class="account-desc">
            Access to your account has been restricted because your organization's status is currently inactive.
            To regain access, please contact your Honeywell support team.
        </p>
    </mat-card-content>
    <mat-card-footer class="footer-text">
        <p>Copyright © {{userDetails.year}} Honeywell International Inc. | Version {{userDetails.versionId}}</p>
    </mat-card-footer>
</mat-card>